import { stashExternalSessionQuery } from '~/utils/external-session-storage';

const routes = {
  index: 'index',
  login: 'login'
};

export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore();

  const userStore = useUserStore();

  // Redirect to the index page if page is public and the user is logged in
  if (to.meta.public && authStore.isLoggedIn) {
    return navigateTo({ name: routes.index, query: to.query });
  }

  // Redirect to the login page if page is not public and the user is not logged in
  if (!to.meta.public && !authStore.isLoggedIn) {
    stashExternalSessionQuery(to.query);
    return navigateTo({ name: routes.login, query: to.query });
  }

  // Logout the user if they are external and trying to access a non-external page or vice versa
  if (
    (to.meta.external && !userStore.isExternalCompany) ||
    (!to.meta.external && !to.meta.public && userStore.isExternalCompany)
  ) {
    stashExternalSessionQuery(to.query);
    await authStore.logout();
  }
});
